export class Share {
	constructor( node ) {
		this.node = node;

		this.openedClass = 'share--open';
		this.opened = this.node.classList.contains(this.openedClass);

		this.node.addEventListener( 'click', (e) => {
			let { target } = e;

			while( target && target !== this.node ) {
				if ( target.classList.contains( 'share__toggler' ) ) {
					e.stopPropagation();
					e.preventDefault();

					return this.toggle();
				}

				target = target.parentNode;
			}
		});
	}

	open() {
		this.opened = true;
		this.node.classList.add( this.openedClass );
	}

	close() {
		this.opened = false;
		this.node.classList.remove( this.openedClass );
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}

export function factory( selector = '.share' ) {
	if ( typeof selector === 'string' ) {
		return Array.from( document.querySelectorAll( selector ) ).map( node => new Share( node ) );
	}

	if ( selector instanceof HTMLElement ) {
		return new Share( selector );
	}

	return [];
}
